import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import VehicleDetails from '../VehicleDetails/VehicleDetails';
import SelectCompanyFirstComponent from '../../components/SelectCompanyFirstComponent';
import { areFeatureTogglesFetched, getSelectedCompany } from '../../store/selectors';
import { Loader } from '../../components';
import Vehicles from './Vehicles';

const renderContent = (selectedCompany, match) => (
  !selectedCompany ? <SelectCompanyFirstComponent /> : (
    <>
      <Route
        exact
        path={`${match.url}`}
        component={Vehicles}
      />
      <Route
        path={`${match.url}/:vehicleId/:providingCompanyId?`}
        component={VehicleDetails}
      />
    </>
  )
);

export default () => {
  const match = useRouteMatch();
  const { t } = useTranslation();
  const selectedCompany = useSelector(getSelectedCompany);
  const featureTogglesFetched = useSelector(areFeatureTogglesFetched);

  return (
    <>
      <BreadcrumbsItem to="/">
        {t('BREADCRUMB.FLEET')}
      </BreadcrumbsItem>
      <BreadcrumbsItem to="/vehicles">
        {t('BREADCRUMB.FLEET_OVERVIEW')}
      </BreadcrumbsItem>
      {!featureTogglesFetched
        ? <Loader text={t('FEATURE_TOGGLES.FETCHING')} />
        : renderContent(selectedCompany, match)}
    </>
  );
};
